<template>
  <div class="b1">
    <div class="flex_between_nowrap">
      <div class="flex_between_nowrap">
        <span class="title_before side_title">损益处理</span>
      </div>
      <div>
        <el-button
          @click="$router.back()"
          type="text"
          class="addColor"
          style="font-size:16px;margin-right:20px;margin-top:20px"
          icon="iconfont icon-shangyibu"
          >返回</el-button
        >
      </div>
    </div>
    <div class="flex_center_nowrap btnbox">
      <div
        @click="tabsFlag('more')"
        :style="
          formParams.checkResult == 'more'
            ? ' border: solid 1px #436bff;color:#436bff'
            : ''
        "
      >
        盘盈
      </div>
      <div
        @click="tabsFlag('little')"
        :style="
          formParams.checkResult == 'little'
            ? ' border: solid 1px #436bff;color:#436bff'
            : ''
        "
      >
        盘亏
      </div>
    </div>
    <div
      class="flex_between_nowrap"
      style="margin-bottom:20px;padding:0px 20px"
    >
      <div>
        <el-select size="small" v-model="formParams['dispose']">
          <el-option
            v-for="item in optionArr"
            :key="item.label"
            :label="item.label"
            :value="item.model"
          ></el-option>
        </el-select>
        <el-input
          clearable
          placeholder="请输入资产名称"
          size="small"
          v-model="formParams['search']"
          style="width:300px;margin-left:10px"
        >
          <i
            slot="suffix"
            class="el-icon-search inputIcon "
            @click.stop="tableSearch"
          ></i>
        </el-input>
      </div>
      <div class="flex_start">
        <el-checkbox
          v-model="formParams['disposeShow']"
          v-if="formParams.checkResult == 'little'"
          :true-label="1"
          @change="tableSearch"
          :false-label="0"
          >只显示可处置资产</el-checkbox
        >
        <el-button
          @click="gainorlossAll"
          v-if="formParams.checkResult == 'little'"
          v-model="formParams['disposeShow']"
          type="submit"
          style="margin-left:10px"
          >{{ "盘亏处置" }}</el-button
        >
      </div>
    </div>
    <x-table
    max-height='500'
      url="/pc/check/page/check/await_dispose"
      ref="xTable"
      :axiosType="true"
      :params="formParams"
        @row-click="table_row_click"

      @selection-change="handleSelectionChange"
    >
      <el-table-column
        reserve-selection
        type="selection"
        v-if="formParams.checkResult == 'little'"
        width="55"
      >
      </el-table-column>
      <el-table-column
        :label="item.label"
        :prop="item.model"
        show-overflow-tooltip
        v-for="item in columnArr"
        :key="item.model"
      >
        <template slot-scope="scope">
          <div style="width:100%" v-if="item.model == 'assetStatus'">
            <el-tag :style="assetStatusFulter(scope.row[item.model], false)">{{
              assetStatusFulter(scope.row[item.model], true)
            }}</el-tag>
          </div>
          <span v-else-if="item.model == 'checkResult'">{{
            scope.row[item.model] == "little" ? "盘亏" : "盘盈"
          }}</span>
          <span v-else-if="item.model == 'dispose'">{{
            scope.row[item.model] ? "是" : "否"
          }}</span>
          <span v-else>{{ scope.row[item.model] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="addColor"
            @click="add_storage(scope.row)"
            v-if="formParams.checkResult == 'more'&&!scope.row.dispose"
            >新增入库</el-button
          >
          <el-button
            type="text"
            class="addColor"
            @click="gainorloss([scope.row.assetId], [scope.row.id])"
            v-if="formParams.checkResult == 'little'&&!scope.row.dispose"
            >盘亏处置</el-button
          >
        </template>
      </el-table-column>
    </x-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      submitData: {
        assetId: [],
        ids: [],
      },
      columnArr: [
        {
          label: "已处置",
          model: "dispose",
        },
        {
          label: "盘点结果",
          model: "checkResult",
        },
        {
          label: "状态",
          model: "assetStatus",
        },
        {
          label: "资产编码",
          model: "assetCode",
        },
        {
          label: "资产名称",
          model: "assetName",
        },
        {
          label: "使用人",
          model: "usePersonName",
        },

        {
          label: "资产分类",
          model: "assetClassifyName",
        },
        {
          label: "所属部门",
          model: "deptName",
        },
        {
          label: "使用部门",
          model: "useDeptName",
        },
        {
          label: "管理人员",
          model: "assetAdminName",
        },
        {
          label: "所在区域",
          model: "areaName",
        },
        {
          label: "资产来源",
          model: "sourceName",
        },
        {
          label: "存放地点",
          model: "depositArea",
        },
        {
          label: "规格型号",
          model: "spec",
        },
        {
          label: "计量单位",
          model: "unit",
        },
        {
          label: "价值",
          model: "price",
        },
        {
          label: "使用期限(月)",
          model: "liveTime",
        },
        {
          label: "入库日期",
          model: "inTime",
        },
      ],

      optionArr: [
        {
          label: "不限",
          model: null,
        },
        {
          label: "未处置",
          model: false,
        },
        {
          label: "已处置",
          model: true,
        },
      ],
      formParams: {
        checkResult: "more",
        dispose: null,
        id: this.$route.query.id,
      },
    };
  },
  mounted() {},
  methods: {
    add_storage(row) {
      let rowData = Object.assign({}, row);
      rowData.checkId = rowData.id;
      delete rowData.id;
      delete rowData.assetId;
      this.$createDialog(this, {
        dialogConfig: { title: "新增入库", width: "860px" },
        namespace: "pd_gainorloss_edit",
        whetherDestruction: true,

        assemblyConfig: {
          rowData,
          callBack: this.tableSearch,
        },
      });
    },table_row_click(row){
  /* 

        @row-click="table_row_click"
   */
this.$refs.xTable.set_checket(row)
},

    gainorlossAll() {
      if (this.submitData.ids.length) {
        this.$createDialog(this, {
          dialogConfig: { title: "盘亏处置", width: "360px" },
          namespace: "pd_gainorloss_little",
          whetherDestruction: true,

          assemblyConfig: {
            assetId: this.submitData.assetId,
            ids: this.submitData.ids,
            callBack: this.tableSearch,
          },
        });
      } else {
        this.$success("操作失败：请选择需要操作的数据!", "error");
      }
    },
    gainorloss(assetId, ids) {
      this.$createDialog(this, {
        dialogConfig: { title: "盘亏处置", width: "360px" },
        namespace: "pd_gainorloss_little",
        whetherDestruction: true,

        assemblyConfig: { assetId, ids, callBack: this.tableSearch },
      });
    },
    handleSelectionChange(data) {
      this.submitData.assetId = [];
      this.submitData.ids = [];

      for (let i = 0; i < data.length; i++) {
        this.submitData.assetId.push(data[i].assetId);
        this.submitData.ids.push(data[i].id);
      }
    },
    tabsFlag(type) {
      this.$set(this.formParams, "search", "");
      this.$set(this.formParams, "dispose", null);
      this.$set(this.formParams, "disposeShow", 0);
      if (type == "more") {
        delete this.formParams.disposeShow;
      }
      this.$set(this.formParams, "checkResult", type);
      this.tableSearch();
    },
    assetStatusFulter(data, flag) {
      let str = "";
      if (flag) {
        switch (data) {
          case "idle":
            str = "闲置";

            break;

          case "use":
            str = "在用";

            break;
          case "borrow":
            str = "借用";

            break;
          case "repair":
            str = "维修中";

            break;
          case "dispose":
            str = "处置";

            break;
          case "examine":
            str = "审批中";

            break;
            case "":
            str = "空";

            break;
        }
      } else {
        switch (data) {
          case "use":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "borrow":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "examine":
            str = "color:#436bff;background:#d8e6ff;";

            break;

          case "idle":
            str = "color:#42b983;background:#f0f9eb;";

            break;
          case "dispose":
            str = "color:#ffa200;background:#ffefd8;";
            break;
          case "repair":
            str = "color:#ffa200;background:#ffefd8;";
            break;
        }
      }
      return str;
    },
    tableSearch() {
      this.$refs.xTable.search();
    },
  },
};
</script>
<style scoped>
.btnbox {
  margin-top: 10px;
  margin-bottom: 20px;
}
.btnbox > div {
  width: 80px;
  height: 36px;
  background-color: #ffffff;
  border: solid 1px #e0e0e0;
  line-height: 36px;
  text-align: center;
  color: #1e1e1e;
  box-sizing: border-box;
}
.btnbox > div:first-child {
  border-radius: 4px 0px 0px 4px;
  border-right: none;
}
.btnbox > div:last-child {
  border-radius: 0px 4px 4px 0px;
  border-left: none;
}
</style>
